// extracted by mini-css-extract-plugin
export default {"button":"KfMdjj09bbOtGAP8coHK"};